// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1CAC9","rootSmall":"AddTileButton_rootSmall__34Kvi"};